// TODO: move this to package/* folder for platformization.

interface Logger {
  log: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
}

class AggregatedLogger {
  private static loggers: Logger[] = [];

  public static addLogger(logger: Logger) {
    if (!this.loggers.find((value) => value === logger)) {
      this.loggers.push(logger);
    }
  }

  public static removeLogger(logger: Logger) {
    this.loggers = this.loggers.filter((value) => value !== logger);
  }

  public static log(...args: unknown[]) {
    this.loggers.forEach((logger) => logger.log(...args));
  }

  public static info(...args: unknown[]) {
    this.loggers.forEach((logger) => logger.info(...args));
  }

  public static warn(...args: unknown[]) {
    this.loggers.forEach((logger) => logger.warn(...args));
  }

  public static error(...args: unknown[]) {
    this.loggers.forEach((logger) => logger.error(...args));
  }

  public static debug(...args: unknown[]) {
    this.loggers.forEach((logger) => logger.debug(...args));
  }
}

export default AggregatedLogger;
